import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft, FaEye, FaEyeSlash } from "react-icons/fa";
import "../style/CreateUser.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function CreateUser() {

  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    username: "",
    password: "",
    role: "EMPLOYEE",
    active: true,

    canCreateCustomer: false,
    canManageGoodsItem: false,
    canManageChallan: false,
    canManageProfile: false,
    canManageSetting: false
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {

    const { name, value, type, checked } = e.target;

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value
    });

  };

  const validateForm = () => {

    const newErrors = {};

    if (!formData.username.trim()) {
      newErrors.username = "Username is required";
    }

    if (!formData.password) {
      newErrors.password = "Password is required";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;

  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (validateForm()) {
    try {

      const response = await fetch(
        "https://ctmapi.zerlak.com/api/v1/settings/users/create",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`
          },
          body: JSON.stringify(formData)
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to create user: ${response.status}`);
      }

      const data = await response.json();

      console.log("User created successfully:", data);

      toast.success("User created successfully!");

      setFormData({
        username: "",
        password: "",
        role: "EMPLOYEE",
        active: true,
        canCreateCustomer: false,
        canManageGoodsItem: false,
        canManageChallan: false,
        canManageProfile: false,
        canManageSetting: false
      });

      setShowPassword(false);

      setTimeout(() => {
        navigate("/dashboard/view-users");
      }, 1500);

    } catch (error) {

      console.error("Error creating user:", error);

      toast.error(error.message || "Failed to create user");

    }
  }
};

  const handleReset = () => {

    setFormData({
      username: "",
      password: "",
      role: "EMPLOYEE",
      active: true,

      canCreateCustomer: false,
      canManageGoodsItem: false,
      canManageChallan: false,
      canManageProfile: false,
      canManageSetting: false
    });

  };

  return (

    <div className="create-user-container">

      <div className="create-user-card">

        {/* HEADER */}

        <div className="create-user-header">

          <h2>Create User</h2>

          <button
            className="btn-back"
            onClick={() => navigate("/dashboard/view-users")}
          >
            <FaArrowLeft /> Back
          </button>

        </div>

        {/* FORM */}

        <form className="create-user-form" onSubmit={handleSubmit}>

          <div className="form-grid">

            {/* USERNAME */}

            <div className="form-field">

              <label>Username</label>

              <input
                type="text"
                name="username"
                value={formData.username}
                onChange={handleChange}
                placeholder="Enter username"
                className={errors.username ? "error" : ""}
              />

              {errors.username && (
                <span className="error-message">
                  {errors.username}
                </span>
              )}

            </div>

            {/* PASSWORD */}

            <div className="form-field">

              <label>Password</label>

              <div className="password-input-container">

                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Enter password"
                  className={errors.password ? "error" : ""}
                />

                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>

              </div>

              {errors.password && (
                <span className="error-message">
                  {errors.password}
                </span>
              )}

            </div>

            {/* ROLE */}

            <div className="form-field">

              <label>Role</label>

              <select
                name="role"
                value={formData.role}
                onChange={handleChange}
              >

                <option value="EMPLOYEE">Employee</option>
                <option value="ADMIN">Admin</option>

              </select>

            </div>

            {/* ACTIVE */}

            <div className="form-field">

              <label>User Active</label>

              <div className="toggle-container">

                <label className="toggle-switch">

                  <input
                    type="checkbox"
                    name="active"
                    checked={formData.active}
                    onChange={handleChange}
                  />

                  <span className="slider"></span>

                </label>

                <span className="toggle-status">
                  {formData.active ? "On" : "Off"}
                </span>

              </div>

            </div>

          </div>

          {/* PERMISSIONS */}

          <div className="permissions-section">

            <h3>Permissions</h3>

            <div className="permissions-grid">

              <div className="permission-item">
                <label className="permission-label">
                  <input
                    type="checkbox"
                    name="canCreateCustomer"
                    checked={formData.canCreateCustomer}
                    onChange={handleChange}
                  />
                  <span className="permission-text">
                    Can Create Customer
                  </span>
                </label>
              </div>

              <div className="permission-item">
                <label className="permission-label">
                  <input
                    type="checkbox"
                    name="canManageGoodsItem"
                    checked={formData.canManageGoodsItem}
                    onChange={handleChange}
                  />
                  <span className="permission-text">
                    Can Manage Goods
                  </span>
                </label>
              </div>

              <div className="permission-item">
                <label className="permission-label">
                  <input
                    type="checkbox"
                    name="canManageChallan"
                    checked={formData.canManageChallan}
                    onChange={handleChange}
                  />
                  <span className="permission-text">
                    Can Manage Challan
                  </span>
                </label>
              </div>

              <div className="permission-item">
                <label className="permission-label">
                  <input
                    type="checkbox"
                    name="canManageProfile"
                    checked={formData.canManageProfile}
                    onChange={handleChange}
                  />
                  <span className="permission-text">
                    Can Manage Profile
                  </span>
                </label>
              </div>

              <div className="permission-item">
                <label className="permission-label">
                  <input
                    type="checkbox"
                    name="canManageSetting"
                    checked={formData.canManageSetting}
                    onChange={handleChange}
                  />
                  <span className="permission-text">
                    Can Manage Settings
                  </span>
                </label>
              </div>

            </div>

          </div>

          {/* BUTTONS */}

          <div className="form-buttons">

            <button
              type="button"
              className="btn-reset"
              onClick={handleReset}
            >
              Reset
            </button>

            <button
              type="submit"
              className="btn-submit"
            >
              Create User
            </button>

          </div>

        </form>

      </div>

    </div>

  );

}

export default CreateUser;